let agents = [
  {
    path: 'agentsList',
    meta: {
      title: '代理列表',
      breadcrumb: true
    },
    component: {
      name: 'agentsList',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/plat/provinceCityAgents/agentsList'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增代理",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/provinceCityAgents/agentsList/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑代理",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/provinceCityAgents/agentsList/editor'], resolve)
      },
      {
        path: 'userInformation',
        meta: {
          title: "用户信息",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/provinceCityAgents/agentsList/userInformation'], resolve)
      }
    ]
  },
  {
    path: 'agentsWithdraw',
    meta: {
      title: '代理提现',
      breadcrumb: true
    },
    component: {
      name: 'agentsWithdraw',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/plat/provinceCityAgents/agentsWithdraw'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "代理提现详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/provinceCityAgents/agentsWithdraw/detail'], resolve)
      }
    ]
  },
  {
    path: 'agentsSettlement',
    meta: {
      title: '代理结算',
      breadcrumb: true
    },
    component: {
      name: 'agentsSettlement',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/plat/provinceCityAgents/agentsSettlement'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "代理结算详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/provinceCityAgents/agentsSettlement/detail'], resolve)
      }
    ]
  },
]

export default {
  path: '/provinceCityAgents',
  redirect: '/provinceCityAgents/agentsList',
  meta: {
      title: "省市代理",
      breadcrumb: true
  },
  component: {
      name: 'provinceCityAgents',
      template: '<router-view></router-view>'
  },
  children: agents
}


// WEBPACK FOOTER //
// ./src/router/provinceCityAgents.js